/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiTableRowActionsContainerProps {
    children: React.ReactNode
    className?: string
}

const UiTableRowActionsContainer = (props: UiTableRowActionsContainerProps) => {
    return (
        <div
            className={clsx(
                'UiTableRowActionsContainer w-full flex items-center justify-end gap-2',
                props.className
            )}
            onClick={(event) => event.stopPropagation()}
        >
            {props.children}
        </div>
    )
}

export default UiTableRowActionsContainer
